import { MPCToolTip } from "../../helpers/toolTip";

export module MPCValuesSubRowModule {
    import ToolTip = MPCToolTip.ToolTip;

    export class SubValuesRow {
        public subFilterTitleContainer: HTMLElement;
        public tooltipContainer: HTMLElement;

        public init(subValuesRow: HTMLElement, mpcModalContainer: HTMLElement): void {
            this.subFilterTitleContainer = subValuesRow.querySelector('.sub-filter-title-container');
            this.tooltipContainer = this.subFilterTitleContainer.querySelector('.tooltip-container');

            // Register toolTip features:
            if (this.tooltipContainer) {
                this.registerToolTipEvents(this.tooltipContainer, mpcModalContainer);
            }
        }

        private registerToolTipEvents(tooltipContainer: HTMLElement, mpcModalContainer: HTMLElement): void {
            new ToolTip(tooltipContainer, mpcModalContainer);
        };
    }
}